import { useMutation } from '@tanstack/react-query';
import { getContentListByDay } from '../../queries/DailySchedule/scheduleContent';

export interface IContentListByDayParams {
  scheduleId: string;
  module: string;
  day: string;
}

export function useGetContentListByDay() {
  const { mutate, isPending, isError, data } = useMutation({
    mutationKey: ['getContentListByDay'],
    mutationFn: ({ scheduleId, module, day }: IContentListByDayParams) =>
      getContentListByDay(scheduleId, module, day),
    retry: false,
  });

  return { mutate, isPending, isError, data };
}
